module.exports = __webpack_public_path__ + "img/wallet.dd8b7173.svg";